function simplePath(path, _params) {
    if (!_params) return path;
    const params = _params;
    const prefix = path.startsWith('/') ? '/' : '';
    const segments = path.split(/\/+/).map((segment)=>{
        var _exec, _params_key;
        const { 1: key } = (_exec = /^[:$](\w+)(\??)$/.exec(segment)) !== null && _exec !== void 0 ? _exec : [];
        if (key) return encodeURIComponent((_params_key = params[key]) !== null && _params_key !== void 0 ? _params_key : '');
        return segment.replace(/\?$/g, '');
    }).filter((segment)=>!!segment);
    return prefix + segments.join('/');
}
export { simplePath };
